<template>
  <div class="englobe-params">
    <div class="params-row">
      <RadioButtons
        :active-option="source"
        :options="options"
        @select-option="source = $event"
      />
    </div>

    <div v-if="natureOptions.length > 1" class="params-row">
      <DropdownMenu
        :model-value="nature ?? 'Toutes'"
        :options="natureOptions"
        label="Commission :"
        @update:model-value="nature = $event === 'Toutes' ? null : $event"
      />
    </div>

    <div class="params-row">
      <TotalMatched :item-count="itemCount" />

      <DropdownMenu
        v-model="pageSize"
        :options="[10, 20, 50, 100]"
        label="Vidéos par page :"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useTranscriptionsStore } from "@/follaw-fr/stores/transcriptions";
import RadioButtons from "../../reusable/atoms/RadioButtons.vue";
import { computed } from "vue";
import TotalMatched from "../../reusable/atoms/TotalMatched.vue";
import DropdownMenu from "../../reusable/atoms/DropdownMenu.vue";
import {
  getInstitutionsNames,
  type InstitutionKey,
} from "@/follaw-fr/utils/institutions.utils";

const { source, nature, availableFilters, itemCount, pageSize } = storeToRefs(
  useTranscriptionsStore()
);

/** Generate nature/commission options based on available filters */
const natureOptions = computed(() => {
  if (!availableFilters.value?.nature) {
    return [];
  }
  return [
    "Toutes",
    ...availableFilters.value.nature.filter((n: string) => n !== "unknown"),
  ];
});

/** Generate options based on available filters (backend data) */
const options = computed(() => {
  if (!availableFilters.value?.source) {
    return [];
  }
  return [
    { label: "Tous", value: null },
    ...availableFilters.value.source.map((sourceLabel: string) => ({
      label: getInstitutionsNames(sourceLabel as InstitutionKey) ?? sourceLabel,
      value: sourceLabel,
    })),
  ];
});
</script>
